import { render, staticRenderFns } from "./NewFieldModalGeneralEffects.vue?vue&type=template&id=c6da9e02&scoped=true&"
import script from "./NewFieldModalGeneralEffects.vue?vue&type=script&lang=js&"
export * from "./NewFieldModalGeneralEffects.vue?vue&type=script&lang=js&"
import style0 from "./NewFieldModalGeneralEffects.vue?vue&type=style&index=0&id=c6da9e02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6da9e02",
  null
  
)

export default component.exports